module.exports = __webpack_public_path__ + "static/img/12.1.3fc719c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/eng/12.1.png
// module id = 0AlH
// module chunks = 0